import { Option } from "components/parts/Input/SelectBox/SelectBox";
import {
  assignOnDisplay,
  checkMonitorArrayBeforeImport,
  detectHeaderChange,
  convertTSVStringToTwoDimensionalArray,
  createDisplayMonitorList,
  createExportArray,
  createOrganizedMap,
  deleteAllMonitorAttributeInTargetSubjectId,
  exportClipboard,
  saveData,
  warningCheckMonitorBeforeImport,
  ErrorModalMessageObject,
  WarningModalMessageObject,
  changeCheckMonitorArrayBeforeImport,
  ChangeModalObject,
  NewlyModalObject,
  newlyCheckMonitorArrayBeforeImport,
} from "pages/MonitorManagement/service";
import { useConsoleState } from "providers/ConsoleStateProvider";
import { useLoadingState } from "providers/LoadingProvider";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Interview,
  InterviewType,
  Monitor,
  MonitorAttribute,
  MonitorCheckResult,
} from "types/graphqlapi";
import { fetchEmailBySubjectIdQuery } from "utils/apis/email";
import { listInterviewsQuery } from "utils/apis/interview";
import { fetchMonitorBysubjectIdQuery } from "utils/apis/monitor";
import { fetchMonitorAssignBysubjectIdQuery } from "utils/apis/monitorAssign";
import { fetchMonitorAttributeBySubjectIdQuery } from "utils/apis/monitorAttribute";
import { listMonitorCheckResultBySubjectIdQuery } from "utils/apis/monitorCheckResult";
import {
  formatDateForDisplay,
  getDisplayMD,
  isInterviewStarted,
} from "utils/common";

export type CheckMonitor = Monitor & {
  assignedInterview?: Interview;
  email?: string;
  monitorAttributeList?: MonitorAttribute[];
};

export type DisplayMonitor = {
  id: string;
  No: string;
  ansId: string;
  classfication: string | null;
  name: string | null;
  sex: string | null;
  age: string | null;
  address: string | null;
  marriage: string | null;
  children: string | null;
  job: string | null;
  assignedInterviewId: string | undefined;
  assignedInterview: Interview | undefined;
  memo: string;
  interviewUrl: string;
  interviewPinCode: string;
  login: boolean;
  email?: string;
};

export type DisplayModalMonitor = {
  id: string;
  ansId: string;
  name: string | null;
  assignedInterviewId: string | undefined;
  assignedInterviewSeq: string | undefined;
  assignedInterview: string | undefined;
};

export type MonitorManagementTableValueType =
  | string
  | number
  | null
  | undefined;

export const useMonitor = () => {
  const history = useHistory();
  const { setLoading } = useLoadingState();
  const {
    selectedGroupId,
    selectedSubjectId,
    selectedSubjectType,
    isPersonalDataHandler,
  } = useConsoleState();

  const [monitorList, setMonitorList] = useState<
    (DisplayMonitor | undefined)[]
  >([]);
  const [modalFlag, setModalFlag] = useState(false);
  const [modalMonitorList, setModalMonitorList] = useState<
    DisplayModalMonitor[]
  >([]);
  const [monitorArray, setMonitorArray] = useState<string[][]>([]);
  const [monitorCheckResultList, setMonitorCheckResultList] = useState<
    MonitorCheckResult[]
  >([]);
  const [errorList, setErrorList] = useState<ErrorModalMessageObject[]>([]);
  const [warningList, setWarningList] = useState<WarningModalMessageObject[]>(
    []
  );
  const [changeList, setChangeList] = useState<ChangeModalObject[]>([]);
  const [newlyList, setNewlyList] = useState<NewlyModalObject[]>([]);

  const refresh = async () => {
    try {
      const displayMonitorList = await createDisplayMonitorList(
        selectedSubjectId
      );
      if (displayMonitorList === undefined) return;

      await fetchMonitorCheckResultList();

      if (isPersonalDataHandler) {
        const emailList = await fetchEmailBySubjectIdQuery(selectedSubjectId);

        setMonitorList(
          displayMonitorList.map((monitor) => ({
            ...monitor,
            email: emailList.find(({ monitor_id }) => monitor.id === monitor_id)
              ?.email,
          }))
        );
      } else {
        setMonitorList(displayMonitorList);
      }
    } catch (error) {
      console.error(error);
      alert("エラーが発生しました。");
      history.replace("/auth/login");
    }
  };

  const createConfirmModalMonitorList = async (
    importArray: string[][],
    chatRoomList: Interview[],
    subjectType: InterviewType,
    isPDH: boolean
  ): Promise<DisplayModalMonitor[]> => {
    const returnArray = importArray
      .filter((row, index) => index !== 0)
      .map((monitor, index) => {
        const startDate = monitor[2];
        const startTime = monitor[3];
        const endDate = monitor[4];
        const endTime = monitor[5];
        const interviewSeq = monitor[6];

        const dateInfoExists =
          subjectType === InterviewType.ONE_TIME
            ? startDate || startTime || endTime
            : startDate || startTime || endDate || endTime;

        const defaultValue = {
          No: (index + 1).toString(),
          id: index.toString(),
          ansId: monitor[0],
          ...(isPDH ? { email: monitor[11] } : {}),
          name: isPDH ? monitor[12] : monitor[11],
          assignedInterviewId: "",
          assignedInterviewSeq: interviewSeq,
          assignedInterview:
            dateInfoExists && subjectType === InterviewType.ONE_TIME
              ? `${formatDateForDisplay(startDate)} ${startTime} 〜 ${endTime}`
              : `${formatDateForDisplay(
                  startDate
                )} ${startTime} 〜 ${formatDateForDisplay(endDate)} ${endTime}`,
        };

        //実査の日時がなく、No.がある場合No.から実査の日時を取得
        if (!dateInfoExists && interviewSeq) {
          const interview = chatRoomList?.find(
            (room) => room.interview_seq.toString() === interviewSeq
          );

          const assignedInterview = interview
            ? subjectType === InterviewType.ONE_TIME
              ? `${formatDateForDisplay(interview.scheduled_start_date)} ${
                  interview.scheduled_start_time
                } 〜 ${interview.scheduled_end_time}`
              : `${formatDateForDisplay(interview.scheduled_start_date)} ${
                  interview.scheduled_start_time
                } 〜 ${formatDateForDisplay(interview.scheduled_end_date)} ${
                  interview.scheduled_end_time
                }`
            : "";

          return {
            ...defaultValue,
            assignedInterview,
          };
          //実査の日時があり、No.がない場合日時から実査のNo.を取得
        } else if (dateInfoExists && !interviewSeq) {
          const sameDateInterviewList = chatRoomList?.filter((room) =>
            subjectType === InterviewType.ONE_TIME
              ? room.scheduled_start_date === startDate &&
                room.scheduled_start_time === startTime &&
                room.scheduled_end_time === endTime
              : room.scheduled_start_date === startDate &&
                room.scheduled_start_time === startTime &&
                room.scheduled_end_date === endDate &&
                room.scheduled_end_time === endTime
          );

          return {
            ...defaultValue,
            assignedInterviewSeq:
              sameDateInterviewList?.length === 1
                ? sameDateInterviewList[0].interview_seq?.toString()
                : undefined,
          };
        } else if (!dateInfoExists && !interviewSeq) {
          return { ...defaultValue, assignedInterview: "未アサイン" };
        } else {
          return defaultValue;
        }
      });

    return returnArray;
  };

  /* インポートした内容をDBに保存＆画面に反映 */
  const saveImportMonitorList = async (
    array: string[][],
    subjectId: string,
    groupId: string,
    subjectType: InterviewType
  ) => {
    const organizedMap = createOrganizedMap(array);
    await saveData(
      organizedMap,
      subjectId,
      groupId,
      subjectType,
      isPersonalDataHandler
    );
    await refresh();
  };

  const readMonitorArrayAndDisplayModal = async (
    draftArray: string[][],
    subjectId: string
  ) => {
    if (
      draftArray[0].find((column) => column === "管理ID") === undefined ||
      draftArray.length < 2
    ) {
      alert("入力データのフォーマットが正しくありません。");
      return;
    }

    const monitorAttributeList = await fetchMonitorAttributeBySubjectIdQuery(
      subjectId
    );

    // ヘッダー変更判定
    if (
      await detectHeaderChange(
        draftArray,
        subjectId,
        monitorAttributeList,
        isPersonalDataHandler
      )
    ) {
      alert(
        "ヘッダー行が変更されておりインポートできません。\n追加属性一括削除を行なってから、再度インポートを行なってください。"
      );
      return;
    }

    let fetchedMonitorList: CheckMonitor[] = await fetchMonitorBysubjectIdQuery(
      subjectId
    );

    const missingAnsIdList = fetchedMonitorList
      .filter(
        ({ ans_id }) =>
          !draftArray
            .map((draft) => draft[0])
            .some((draftAnsId) => draftAnsId === ans_id)
      )
      .map(({ ans_id }) => ans_id);

    if (missingAnsIdList.length > 0) {
      alert(
        `登録済みのモニターが不足しています。\n管理ID：${missingAnsIdList.join(
          ", "
        )}\nインポートできません。`
      );
      return;
    }

    const interviewList = await listInterviewsQuery(subjectId);
    const monitorAssignList = await fetchMonitorAssignBysubjectIdQuery(
      subjectId
    );

    fetchedMonitorList = fetchedMonitorList.map((monitor) => {
      const targetMonitorAssignList = monitorAssignList
        .filter(({ monitor_id }) => monitor_id === monitor.id)
        .sort((a, b) => (a.createdAt > b.createdAt ? 1 : -1));

      const targetMonitorAttributeList = monitorAttributeList
        .filter(({ monitor_id }) => monitor_id === monitor.id)
        .sort((a, b) => (a.seq_no > b.seq_no ? 1 : -1));

      return {
        ...monitor,
        assignedInterview: interviewList.find(
          ({ id }) =>
            id ===
            targetMonitorAssignList[targetMonitorAssignList.length - 1]
              ?.interview_id
        ),
        monitorAttributeList:
          targetMonitorAttributeList.length > 0
            ? targetMonitorAttributeList
            : undefined,
      };
    });

    if (isPersonalDataHandler) {
      const emailList = await fetchEmailBySubjectIdQuery(subjectId);
      fetchedMonitorList = fetchedMonitorList.map((monitor) => {
        return {
          ...monitor,
          email:
            emailList.find(({ monitor_id }) => monitor_id === monitor.id)
              ?.email || "",
        };
      });
    }

    if (!selectedSubjectType) return;
    const checkResult = await checkMonitorArrayBeforeImport(
      draftArray,
      interviewList,
      fetchedMonitorList,
      selectedSubjectType,
      isPersonalDataHandler
    );

    if (checkResult?.length > 0) {
      setErrorList(checkResult);
    }

    if (isPersonalDataHandler) {
      const warningCheckResult = await warningCheckMonitorBeforeImport(
        draftArray
      );

      if (warningCheckResult?.length > 0) {
        setWarningList(warningCheckResult);
      }
    }

    const checkChangeResult = await changeCheckMonitorArrayBeforeImport(
      draftArray,
      subjectId,
      fetchedMonitorList,
      selectedSubjectType,
      isPersonalDataHandler
    );

    if (checkChangeResult?.length > 0) {
      setChangeList(checkChangeResult);
    }

    const checkNewlyResult = await newlyCheckMonitorArrayBeforeImport(
      draftArray,
      fetchedMonitorList
    );

    if (checkNewlyResult?.length > 0) {
      setNewlyList(checkNewlyResult);
    }

    const confirmMonitorList = await createConfirmModalMonitorList(
      draftArray,
      interviewList,
      selectedSubjectType,
      isPersonalDataHandler
    );
    setModalMonitorList(confirmMonitorList);
    setMonitorArray(draftArray);
    setModalFlag(true);
  };

  const importTSV = async (inputString: string, subjectId: string) => {
    const draftArray = convertTSVStringToTwoDimensionalArray(inputString);
    setLoading(true);

    try {
      await readMonitorArrayAndDisplayModal(draftArray, subjectId);
    } catch (error) {
      console.error(error);
      alert("エラーが発生しました。");
      history.replace("/auth/login");
    } finally {
      setLoading(false);
    }
  };

  const onPasteTSVImportHandler = async (inputString: string) => {
    setLoading(true);
    try {
      await importTSV(inputString, selectedSubjectId);
    } catch (error) {
      console.error(error);
      alert("エラーが発生しました。");
      history.replace("/auth/login");
    } finally {
      setLoading(false);
    }
  };

  const importMonitor = async () => {
    if (!selectedSubjectType) return;
    setLoading(true);

    try {
      await saveImportMonitorList(
        monitorArray,
        selectedSubjectId,
        selectedGroupId,
        selectedSubjectType
      );
    } catch (error) {
      console.error(error);
      alert("エラーが発生しました。");
      history.replace("/auth/login");
    } finally {
      setModalFlag(false);
      setModalMonitorList([]);
      setErrorList([]);
      setWarningList([]);
      setChangeList([]);
      setNewlyList([]);
      setLoading(false);
    }
  };

  const onClickTSVExportHandler = async () => {
    setLoading(true);
    try {
      const exportArray = await createExportArray(
        selectedSubjectId,
        isPersonalDataHandler,
        selectedSubjectType
      );
      await exportClipboard(exportArray);
      alert("コピーが完了しました。");
    } catch (error) {
      console.error(error);
      if (
        error instanceof DOMException &&
        error.message === "Document is not focused."
      ) {
        alert("コピーに失敗しました。もう一度操作してください。");
      } else {
        alert("エラーが発生しました。");
        history.replace("/auth/login");
      }
    } finally {
      setLoading(false);
    }
  };

  const onClickDeleteMonitorAttribute = async () => {
    if (confirm("モニターの追加属性を全て削除します。よろしいですか？")) {
      setLoading(true);
      try {
        await deleteAllMonitorAttributeInTargetSubjectId(selectedSubjectId);
        alert("削除が完了しました。");
      } catch (error) {
        console.error(error);
        alert("削除に失敗しました。");
      } finally {
        setLoading(false);
      }
    }
  };

  const onChangePulldownHandler = async (
    e: React.ChangeEvent<HTMLSelectElement>,
    monitorId: string,
    assignedInterviewId: string | undefined
  ) => {
    setLoading(true);
    try {
      await assignOnDisplay(
        selectedSubjectId,
        e.target.value,
        selectedGroupId,
        monitorId,
        assignedInterviewId
      );
      await refresh();
    } catch (error) {
      console.error(error);
      alert("エラーが発生しました。");
      history.replace("/auth/login");
    } finally {
      setLoading(false);
    }
  };

  const fetchMonitorCheckResultList = async () => {
    try {
      setLoading(true);
      const monitorCheckResultList =
        await listMonitorCheckResultBySubjectIdQuery(selectedSubjectId);
      setMonitorCheckResultList(monitorCheckResultList);
    } catch (error) {
      console.error(error);
      alert("エラーが発生しました。");
      history.replace("/auth/login");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      await refresh();
      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    errorList,
    warningList,
    changeList,
    newlyList,
    modalFlag,
    modalMonitorList,
    monitorArray,
    monitorList,
    monitorCheckResultList,
    onChangePulldownHandler,
    onClickDeleteMonitorAttribute,
    importMonitor,
    onClickTSVExportHandler,
    onPasteTSVImportHandler,
    setErrorList,
    setWarningList,
    setChangeList,
    setNewlyList,
    setModalFlag,
    setModalMonitorList,
    setMonitorCheckResultList,
    refresh,
  };
};

export const useInterviewListForSelect = () => {
  const history = useHistory();
  const { selectedSubjectId, selectedSubjectType } = useConsoleState();
  const [interviewList, setInterviewList] = useState<Option[]>([]);

  /**
   * プルダウン用インタビューリスト取得
   * @returns
   */
  const fetchInterviewList = async (subjectId: string) => {
    try {
      const InterviewList = await listInterviewsQuery(subjectId);

      if (InterviewList === undefined) return [];
      const interviewPulldownList = InterviewList.sort((a, b) => {
        if (a && b) {
          if (a.interview_seq < b.interview_seq) return -1;
          if (a.interview_seq > b.interview_seq) return 1;
        }
        return 0;
      })
        .filter((interview) => {
          return !isInterviewStarted(interview) && interview.canceled === 0;
        })
        .map((interview) => {
          return {
            value: interview.id,
            text: `${interview.interview_seq} ${
              interview.scheduled_start_date
                ? getDisplayMD(new Date(interview.scheduled_start_date))
                : ""
            } ${interview.scheduled_start_time} ～ ${
              selectedSubjectType === InterviewType.TERM &&
              interview.scheduled_end_date
                ? getDisplayMD(new Date(interview.scheduled_end_date))
                : ""
            } ${interview.scheduled_end_time}`,
          };
        });
      // interviewPulldownList.unshift({ value: "0", text: "未アサイン" });
      setInterviewList([
        { value: "0", text: "未アサイン" },
        ...interviewPulldownList,
      ]);
    } catch (error) {
      console.error(error);
      alert("エラーが発生しました。");
      history.replace("/auth/login");
    }
  };

  useEffect(() => {
    fetchInterviewList(selectedSubjectId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { interviewList };
};
